@if (fundDistributed == null) {
  <section class="fund-spread-container">
    <section class="header-container">
      <h1>
        Distribute Funds: <span>{{ data.application?.fullName }}</span>
      </h1>
      <p>Please distribute funds for this student</p>
    </section>
    <mat-dialog-content class="dialog-content">
      <section class="amount-container">
        <p>Total bursary amount</p>
        <p class="amount">{{ data.application?.amount | customCurrency }}</p>
      </section>
      <form [formGroup]="expensesForm" (ngSubmit)="postExpense()">
        <section class="table-container">
          <section class="form-container">
            <mat-form-field appearance="outline" class="search-input">
              <span matPrefix id="prefix">R &nbsp;</span>
              <mat-label class="label">Tuition</mat-label>
              <input
                matInput
                type="number"
                formControlName="tuition"
                placeholder="Enter amount"
                [defaultValue]="0"
                class="label"
              />
              @if (expensesForm.get("tuition")?.hasError("pattern")) {
                <mat-error> Please enter a valid number. </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
              <span matPrefix id="prefix">R &nbsp;</span>
              <mat-label class="label">Accommodation</mat-label>
              <input
                matInput
                type="number"
                formControlName="accommodation"
                placeholder="Enter amount"
                [defaultValue]="0"
                class="label"
              />
              @if (expensesForm.get("accommodation")?.hasError("pattern")) {
                <mat-error> Please enter a valid number. </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
              <span matPrefix id="prefix">R &nbsp;</span>
              <mat-label class="label">Meals</mat-label>
              <input
                matInput
                type="number"
                formControlName="meals"
                placeholder="Enter amount"
                [defaultValue]="0"
                class="label"
              />
              @if (expensesForm.get("meals")?.hasError("pattern")) {
                <mat-error> Please enter a valid number. </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
              <span matPrefix id="prefix">R &nbsp;</span>
              <mat-label class="label">Other</mat-label>
              <input
                matInput
                type="number"
                formControlName="other"
                placeholder="Enter amount"
                [defaultValue]="0"
                class="label"
              />
              @if (expensesForm.get("other")?.hasError("pattern")) {
                <mat-error> Please enter a valid number. </mat-error>
              }
            </mat-form-field>
          </section>
          <section class="other-input-container">
            @if (expensesForm.get("other")?.value) {
              <mat-form-field appearance="outline" class="other-input">
                <mat-label class="other-label"
                  >Details of what "Other" is</mat-label
                >
                <input
                  matInput
                  type="text"
                  placeholder="Enter details"
                  formControlName="reason"
                />
                @if (
                  expensesForm.get("other")?.value > 0 &&
                  expensesForm.get("reason")?.hasError("required")
                ) {
                  <mat-error> This field is required. </mat-error>
                }
                @if (expensesForm.get("reason")?.hasError("pattern")) {
                  <mat-error> Please enter valid text. </mat-error>
                }
              </mat-form-field>
            }
          </section>
          @if (!allFieldsFilled) {
            <p class="error-message">
              *The total amount does not match the application amount.
            </p>
          }
        </section>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions class="funds-button-container">
      <button mat-flat-button color="accent" matDialogClose>Cancel</button>
      <section class="action-button">
        <button
          mat-flat-button
          color="primary"
          [disabled]="
            !isFundSpreadCorrect ||
            (expensesForm.get('other')?.value > 0 &&
              !expensesForm.get('reason')?.value)
          "
          (click)="openConfirmationDialog()"
        >
          Submit fund distribution
        </button>
      </section>
    </mat-dialog-actions>
  </section>
}
@if (fundDistributed == true) {
  <section #confirmDialog class="confirm-container">
    <h2 mat-dialog-title class="dialog-title">
      Confirm Fund Distribution:&nbsp;
      <span class="dialog-title__name">{{ data.application.fullName }}</span>
    </h2>
    <p class="dialog-subtitle">
      Please confirm that you are happy with how you have distributed funds for
      this student
    </p>
    <p class="dialog-subheading">Fund distribution</p>
    <mat-dialog-content class="dialog-content">
      <mat-grid-list
        rowHeight="2rem"
        class="custom-grid"
        [gridCols]="{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }"
      >
        @if (expensesForm.value.tuition > 0) {
          <mat-grid-tile class="dialog-content-container">
            <p class="dialog-content-label">Tuition:</p>
            <p class="dialog-content-value">
              {{ expensesForm.value.tuition | customCurrency }}
            </p>
          </mat-grid-tile>
        }
        @if (expensesForm.value.accommodation > 0) {
          <mat-grid-tile class="dialog-content-container">
            <p class="dialog-content-label">Accommodation:</p>
            <p class="dialog-content-value">
              {{ expensesForm.value.accommodation | customCurrency }}
            </p>
          </mat-grid-tile>
        }
        @if (expensesForm.value.meals > 0) {
          <mat-grid-tile class="dialog-content-container">
            <p class="dialog-content-label">Meals:</p>
            <p class="dialog-content-value">
              {{ expensesForm.value.meals | customCurrency }}
            </p>
          </mat-grid-tile>
        }
        @if (expensesForm.value.other > 0) {
          <mat-grid-tile class="dialog-content-container">
            <p class="dialog-content-label">
              Other ({{ expensesForm.value.reason }}):
            </p>
            <p class="dialog-content-value">
              {{ expensesForm.value.other | customCurrency }}
            </p>
          </mat-grid-tile>
        }
        <mat-grid-tile class="dialog-content-container">
          <mat-divider class="divider"></mat-divider>
        </mat-grid-tile>
        <mat-grid-tile class="dialog-content-container">
          <p class="dialog-content-label">Total bursary amount:</p>
          <p class="dialog-content-value">{{ totalAmount | customCurrency }}</p>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
      <button
        mat-button
        mat-dialog-close
        color="accent"
        class="dialog-actions__button"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="isExpensePosted"
        (click)="postExpense()"
        class="dialog-actions__button"
      >
        Confirm fund distribution
      </button>
    </mat-dialog-actions>
  </section>
}
